// languages.js
export const languages = {
    en: {
      name: 'English',
      flag: '/img/lang/icons8-usa-36.png',
    },
    fr: {
      name: 'Français',
      flag: '/img/lang/emojione_flag-for-france.png',
    },
    // Ajoutez d'autres langues ici
    es: {
      name: 'Español',
      flag: '/img/lang/icons8-spain-36.png',
    },
  };
  